import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { LoadingProvider } from './context/LoadingContext'
import { ServiceDataProvider } from './context/ServiceDataContext.jsx'
import './index.css'
import App from './App.jsx'

// Disable automatic scroll restoration
if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

createRoot(document.getElementById('root')).render(
    <BrowserRouter>
      <LoadingProvider>
        <ServiceDataProvider>
          <App />
        </ServiceDataProvider>
      </LoadingProvider>
    </BrowserRouter>
)
